export enum ROUTES {
  INITIAL_ROUTE = "/",
  DASHBOARD = "/dashboard",
  LOGIN_CALLBACK = "/login-callback",
  LOGOUT_CALLBACK = "/logout-callback",
  AML_VALIDATION = "/aml-validation",
  COMPANIES = "/companies",
  OLD_CLIENTS = "/clients",
  VERIFICATION = "/aml-verification",
}
